import { render, staticRenderFns } from "./TermsUpdatedView.vue?vue&type=template&id=6b5ca667"
import script from "./TermsUpdatedView.vue?vue&type=script&lang=js"
export * from "./TermsUpdatedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports